var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('greeter'),_c('navbar',{style:(_vm.navStyle),attrs:{"current":'profile'},on:{"openresume":_vm.openResume}}),_c('bio',{on:{"openresume":_vm.openResume}}),_c('experience'),_c('skills'),_c('projects')],1)}
var staticRenderFns = []

export { render, staticRenderFns }